define(function () {
  return /\?/;
});